<div class="container" [attr.data-tick]="refreshTick()">
  <div class="filter-box">
    <mat-form-field >
      <mat-label>סינון</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="חפש..." #input>
    </mat-form-field>
    <button class="refreshBtn" [disabled]="isLoadingResults()" mat-mini-fab color="primary" (click)="refreshCampaignsData()" matTooltip="רענן נתונים">
      <mat-icon>refresh</mat-icon>
    </button>
    <button mat-mini-fab color="primary" [disabled]="isLoadingReport()" (click)="downloadCampaignsReports()" matTooltip='הורד דו"ח קמפינים (חודש אחרון)'>
      @if (!isLoadingReport()) {
        <mat-icon>save_alt</mat-icon>
      }
      @if (isLoadingReport()) {
        <mat-spinner diameter="24" color="warn"></mat-spinner>
      }
    </button>
  </div>

  @if (isLoadingResults()) {
    <div class="loading-shade-table">
      <mat-spinner></mat-spinner>
    </div>
  }

  <div>
    @if (!isLoadingResults()) {
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="details-table" multiTemplateDataRows matSort>
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
            <td mat-cell *matCellDef="let element">
              {{element.campaignId}}
            </td>
            <ng-container matColumnDef="friendlyName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> שם קמפיין </th>
              <td mat-cell *matCellDef="let element"> {{element.friendlyName}} </td>
            </ng-container>
            <ng-container matColumnDef="ownerUnitName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> יחידה </th>
              <td mat-cell *matCellDef="let element"> {{element.ownerUnitName}} </td>
            </ng-container>
            <ng-container matColumnDef="applicationName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> אפליקציה </th>
              <td mat-cell *matCellDef="let element"> {{element.applicationName}} </td>
            </ng-container>
            <ng-container matColumnDef="regionName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> אזור </th>
              <td mat-cell *matCellDef="let element"> {{element.regionName}} </td>
            </ng-container>
            <ng-container matColumnDef="anchorType">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> סוג עוגן </th>
              <td mat-cell *matCellDef="let element"> {{element.anchorType}} </td>
            </ng-container>
            <ng-container matColumnDef="statusName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> סטטוס </th>
              <td mat-cell *matCellDef="let element" [ngStyle]="{'color':element.statusId|campaignStatusColor}">
                @if (element.statusId !== -1) {
                  <div>{{element.statusName}}</div>
                } @else {
                  MULTI-STATUSES
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="createdDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ת. יצירה </th>
              <td mat-cell *matCellDef="let element"> {{element.createdDate |date:"HH:mm dd/MM/yyyy"}} </td>
            </ng-container>
            <ng-container matColumnDef="cancel">
              <th mat-header-cell *matHeaderCellDef> </th>
              <td mat-cell *matCellDef="let element" >
                @if (element.statusId == 1 && !isCancelingCampaign()) {
                  <button mat-raised-button color="warn" [disabled]="isCancelingCampaign()" (click)="onCancelCampaignClick($event,element)" matTooltip="בטל קמפיין">Cancel
                  </button>
                }
                @if (element.statusId == 1 && isCancelingCampaign()) {
                  <mat-spinner diameter="34" color="warn"></mat-spinner>
                }
              </td>
            </ng-container>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" [attr.colspan]="dataSource.data.length">

              <div class="status-summary-data" [class.expanded]="element == expandedElement">

                <label class="summary-title">תוצאות קמפיין</label>

                @if (element.applicationId === 'FB' || element.applicationId === 'TGE' || element.applicationId === 'TK') {
                  @if (botanicCampaignStatus() === undefined) {
                    <div class="spinner-item">
                      <mat-spinner [diameter]="50"></mat-spinner>
                    </div>
                  } @else {
                    @if (botanicCampaignStatus()) {
                      <mat-list role="list" class="horizontal-list">
                        <mat-list-item role="listitem">
                          <span class="status-counter">תוזמן: {{botanicCampaignStatus()!.count_scheduled | number}}</span>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                          <span class="status-counter">נשלח לביצוע: {{botanicCampaignStatus()!.count_executed | number}}</span>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                          <span class="status-counter">ממתין לביצוע: {{botanicCampaignStatus()!.count_waiting | number}}</span>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                          <span class="status-counter" style="color: goldenrod;">בפעולה: {{botanicCampaignStatus()!.count_running | number}}</span>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                          <span class="status-counter" style="color: green;">הצליח: {{botanicCampaignStatus()!.count_succeeded | number}}</span>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                          <span class="status-counter" style="color: red;">נכשל: {{botanicCampaignStatus()!.count_failed | number}}</span>
                        </mat-list-item>
                        <mat-list-item role="listitem">
                          <button mat-icon-button color="primary" (click)="refreshBotanicStatus(element)" matTooltip="רענן">
                            <mat-icon>refresh</mat-icon>
                          </button>
                        </mat-list-item>
                      </mat-list>
                    } @else {
                      <label class="no-status-summary-data">*לא נמצאו נתונים</label>
                    }
                  }
                } @else {
                  @if (element.campaignStatusSummary == undefined) {
                    <div class="spinner-item">
                      <mat-spinner [diameter]="50"></mat-spinner>
                    </div>
                  } @else {
                    @if (element.campaignStatusSummary.anchorStatus?.length) {
                      <mat-list role="list" class="horizontal-list">
                        @for (item of element.campaignStatusSummary.anchorStatus; track item) {
                          <mat-list-item role="listitem">
                            <button mat-mini-fab class="action-btn" color="primary"
                              (click)="getCampaignStatusDetailsService(element,item)">
                              <mat-icon class="icon-display">list_alt</mat-icon>
                            </button>
                            <span class="status-counter">{{item.status}}: {{item.counter |number}}</span>
                          </mat-list-item>
                        }
                      </mat-list>
                    } @else {
                      <label class="no-status-summary-data">*לא נמצאו נתונים</label>
                    }
                  }
                }
              </div>

            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true"></tr>
          <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="element-row"
            [class.expanded-row]="expandedElement === element"
            (click)="expandedElement = expandedElement === element ? null : element;getAnchorStatusCounters(expandedElement)">
          </tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4">לא נמצאו נתונים לחיפוש: "{{input.value}}"</td>
          </tr>

        </table>
      </div>
    }
    <mat-paginator  showFirstLastButtons [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]">
    </mat-paginator>
  </div>
</div>
